import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  Grid,
  Box,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Typography,
  Button,
} from '@material-ui/core';

// import { useSelector, useDispatch } from "react-redux";
import Divider from '@material-ui/core/Divider';

import { Link } from 'react-router-dom';

// import constants & router constants
import {
  SYSTEM_NAME_FRONTOF,
  SYSTEM_NAME_FRONTOF_TH,
  sysURL,
} from './../../../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '30vh',
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      maxWidth: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 420,
      maxWidth: 420,
      marginTop: 20,
    },
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  media: {
    height: 120,
    display: 'flex',
    verticalAlign: 'middle',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageSize: {
    height: 80,
    /*marginRight: theme.spacing(2),*/
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  cardContent: {
    margin: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(2, 0, 1),
  },
}));

export default (props) => {
  const classes = useStyles();
  // const dispatch = useDispatch();
  // const loginReducer = useSelector(({ loginReducer }) => loginReducer);

  return (
    <React.Fragment>
      <Container>
        <Card className={classes.root}>
          <CardMedia className={classes.media} title="">
            <img
              src={`${process.env.PUBLIC_URL}/images/mu_logo_full.png`}
              className={classes.imageSize}
            />
          </CardMedia>

          <Divider />

          <CardContent className={classes.cardContent}>
            <Typography variant="h6" component="h1" align="center">
              Sign in to <br />
              {SYSTEM_NAME_FRONTOF}
            </Typography>
            <br />
            <Typography
              variant="body2"
              color="textSecondary"
              component="h1"
              gutterBottom
              align="center"
            >
              Click ที่ปุ่ม SIGN IN เพื่อเข้าสู่ <br />
              การลงชื่อเข้าใช้ {SYSTEM_NAME_FRONTOF_TH}
            </Typography>
            <Box pt={3}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                // component={Link}
                // to={`${PATH_FRONTOF_MASTER}/main`}
                onClick={(e) => {
                  e.preventDefault();
                  window.location = sysURL.adfsAuthen;
                }}
              >
                Sign In
              </Button>
            </Box>
            <Grid container justify="flex-end"></Grid>
          </CardContent>
          {/* <CardActions>
          <Button size="small" color="primary">
            Learn More
          </Button>
        </CardActions> */}
        </Card>
      </Container>
    </React.Fragment>
  );
};
